<section *ngIf="tags().length">
  <h2>{{ filter.label }}</h2>

  <div class="tags">
    <ng-container *ngFor="let tag of tags()">
      <opac-button (click)="navigateTag(tag)"> {{ tag.label }} </opac-button>

      <ng-container *ngIf="tag.nextLevel">
        <opac-button *ngFor="let nextTag of tag.nextLevel" (click)="navigateTag(nextTag)"> {{ nextTag.label }} </opac-button>
      </ng-container>
    </ng-container>
  </div>
</section>
